import { render, staticRenderFns } from "./login.component.vue?vue&type=template&id=5b4b1e7e&scoped=true"
import script from "./login.component.vue?vue&type=script&lang=js"
export * from "./login.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4b1e7e",
  null
  
)

export default component.exports